import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexRow from '@ui/atoms/FlexRow';
import HeadingText from '@ui/atoms/HeadingText';

import RoundedCard from '@ui/molecules/RoundedCard';

import { exists } from '@utils/general';
import { centsToDollars } from '@utils/money';

interface ISubscriptionCardProps {
	bottomText?: ReactNode;
	topText?: string;
	price?: number | null;
	interval?: string;
}

const PriceRow = styled(FlexRow)`
	gap: 0.6rem;
	align-items: center;

	${BasicText} {
		line-height: 0;
	}
`;

const SubscriptionCard: FC<ISubscriptionCardProps> = ({
	bottomText,
	interval = 'month',
	price,
	topText,
}) => {
	return (
		<RoundedCard
			bgColor="cardBeige"
			headerMargin="xssm"
			footerMargin="xssm"
			header={exists(topText) && <BasicText variant="fineprintBold">{topText}</BasicText>}
			body={
				exists(price) && (
					<PriceRow>
						<HeadingText>{centsToDollars(price ?? 0)}</HeadingText>
						<BasicText variant="fineprint">/{interval}</BasicText>
					</PriceRow>
				)
			}
			footer={exists(bottomText) && bottomText}
		/>
	);
};

export default styled(SubscriptionCard)``;
